import { render, staticRenderFns } from "./LanguageSelectListSection.vue?vue&type=template&id=607ea8b2&scoped=true"
import script from "./LanguageSelectListSection.vue?vue&type=script&lang=ts"
export * from "./LanguageSelectListSection.vue?vue&type=script&lang=ts"
import style0 from "./LanguageSelectListSection.vue?vue&type=style&index=0&id=607ea8b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607ea8b2",
  null
  
)

export default component.exports